import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import storePayload from './modules/globals/payload/index';
import storePermissions from './modules/globals/permissions/index';
import storeUser from './modules/globals/user/index';

Vue.use( Vuex );

const vuexLocalStorage = new VuexPersist({
    storage: window.localStorage,
    // Função para guardar apenas os modulos que pretendemos guardar em localstorage.
    reducer: state => ({
        storeUser: { user: state.storeUser.user }
    })
});

export default new Vuex.Store({
    modules: {
        storePayload,
        storePermissions,
        storeUser
    },
    plugins: [ vuexLocalStorage.plugin ]
});